import Component from 'antd/es/upload';
import 'antd/lib/upload/style';
export default Component;
